const BASE_URL: string = process.env.NEXT_PUBLIC_API_URL || "";
export const BASE_PATH: string = process.env.NEXT_PUBLIC_BASE_PATH || "";

export const CONSTANT = {
  LOGIN: "/authentication/session",

  LOADING_PLEASE_WAIT: "Please wait...",

  REQUEST_SUCCESS: "Success process request",
  REQUEST_SUCCESS_INSERT: "New data inserted successfully",
  REQUEST_SUCCESS_UPDATE: "Data updated successfully",
  REQUEST_SUCCESS_DELETE: "Data deleted successfully",
  REQUEST_SUCCESS_UPLOAD: "File(s) uploaded successfully",
  REQUEST_SUCCESS_SHOW_ALL: "All data has been displayed",
  REQUEST_SUCCESS_NO_DATA: "No more data available",
  REQUEST_SUCCESS_STOP: "Stop successfully",
  REQUEST_SUCCESS_SYNC: "Sync data successfully",

  REQUEST_FAILED: "Failed to process request",
  REQUEST_FAILED_INSERT: "Failed to insert new data",
  REQUEST_FAILED_UPDATE: "Failed to update data",
  REQUEST_FAILED_DELETE: "Failed to delete data",
  REQUEST_FAILED_UPLOAD: "Failed to upload file(s)",
  REQUEST_FAILED_UPLOAD_MAX_SIZE:
    "File upload failed. Exceeds the allowed maximum size.",
  REQUEST_FAILED_UPLOAD_INVALID_SIGNATURE:
    "File upload failed. Content does not match the expected signature.",
  REQUEST_FAILED_UPLOAD_INVALID_TEMPLATE:
    "File upload failed. File template invalid.",
  REQUEST_FAILED_BAD_REQUEST: "Bad request, please check your input", // 400
  REQUEST_FAILED_LOG_NOT_FOUND: "Summary log file not found", // 404
  REQUEST_FAILED_TEMPLATE: "Incorrect file template, please check your file", // 400
  REQUEST_FAILED_EXTENSION: "Incorrect file extension, please check your file",
  REQUEST_FAILED_UNAUTHORIZED:
    "Unauthorized, please log in to identify yourself", // 401
  REQUEST_FAILED_FORBIDDEN:
    "Access forbidden, you are not eligible to access this feature, please log in with another account", // 403
  REQUEST_FAILED_INVALID_VERSION: "Invalid or inactive version.", // 403
  REQUEST_FAILED_NOT_FOUND: "Data not found", // 404
  REQUEST_FAILED_INVALID_URI: "Unable to open URL in the browser",

  BUTTON_OK: "OK",
  BUTTON_CANCEL: "Cancel",
  BUTTON_SAVE: "Save",
  BUTTON_DELETE: "Delete",
  CONFIRM_ADD: "Do you want to save this data?",
  CONFIRM_EDIT: "Do you want to update this data?",
  CONFIRM_DELETE: "Are you sure you want to delete this data?",

  REQUEST_ERROR: "Error while processing the request",
  REQUEST_ERROR_NO_SERVICE_AVAILABLE:
    "Service not available at this moment, please check again later",
  REQUEST_ERROR_INTERNAL_SERVER:
    "Something is wrong with the server, please contact your web administrator",
  REQUEST_ERROR_NOT_IMPLEMENTED: "Method not yet implemented",

  TOKEN_FAILED_INVALID: "Invalid token, please log in again",
  TOKEN_FAILED_EXPIRED: "Expired token, please log in again",

  PAGE_NUMBER_INVALID: "Invalid page number",
  PAGE_SIZE_INVALID: "Invalid page size",

  USER_FAILED_UNAUTHORIZED: "You are not allowed to access this platform",
  USER_FAILED_INACTIVE:
    "Your username is either inactive or locked, please contact the administrator",
  USER_FAILED_INVALID: "Either the username or password is invalid",
  USER_FAILED_NOT_EXIST: "User does not exist",
  USER_FAILED_LOCKED: "Maximum login attempts reached, the user will be locked",
  USER_FAILED_OTP: "Invalid OTP",

  USER_SUCCESS_FORGOT_CREDENTIAL:
    "Your request has been processed, please check your email",
  USER_SUCCESS_CHANGE_CREDENTIAL:
    "Password change successful, you will be redirected to the login page",

  FORMAT_DATETIME: "yyyy-MM-dd HH:mm:ss",
  FORMAT_DATE: "yyyy-MM-dd",
  FORMAT_TIME: "HH:mm:ss",

  CONFIGKEY_APP_ENV: "Application:Environment",
  CONFIGKEY_APP_DB: "Application:Database",
  CONFIGKEY_MODIFY_APP_ENV: "Application:AllowOverrideEnvironment",
  CONFIGKEY_MODIFY_APP_DB: "Application:AllowOverrideDatabase",
  VARIABLE_APP_ENV: "SEMOLIS_V2 NEXTJS_ENVIRONMENT",
  VARIABLE_APP_DB: "SEMOLIS_V2 NEXTJS_DATABASE",

  TIMEOUT_APP: 30000,
  TIMEOUT_DB: 30000,

  CLIENT_TYPE: "X-CLIENT-TYPE",
  CLIENT_VERSION: "X-CLIENT-VERSION",

  CLAIM_TYPE_LOGIN_ID: "login_id",
  CLAIM_TYPE_USER_ID: "user_id",
  CLAIM_TYPE_USER_NAME: "user_name",
  CLAIM_TYPE_ROLE_NAME: "role_name",
  CLAIM_TYPE_CLIENT_TYPE: "client_type",
  CLAIM_TYPE_CLIENT_VERSION: "client_version",
  CLAIM_TYPE_SIGNED_ON: "signed_on",
  CLAIM_TYPE_SPECIAL_PERMISSION: "special",
  CLAIM_TYPE_REGULAR_PERMISSION: "reguler",

  PERMISSION_VIEW: "V",
  PERMISSION_ADD: "A",
  PERMISSION_UPDATE: "U",
  PERMISSION_DELETE: "D",
  PERMISSION_PRINT: "P",

  PERMISSION_GUEST: "F0:G",
  PERMISSION_APP_SETTING_VIEW: "F1:V",
  PERMISSION_APP_SETTING_ADD: "F1:A",
  PERMISSION_APP_SETTING_UPDATE: "F1:U",
  PERMISSION_APP_SETTING_DELETE: "F1:D",
  PERMISSION_APP_SETTING_PRINT: "F1:P",
  PERMISSION_APP_SETTING_ACCESS_VIEW: "F2:V",
  PERMISSION_APP_SETTING_ACCESS_ADD: "F2:A",
  PERMISSION_APP_SETTING_ACCESS_UPDATE: "F2:U",
  PERMISSION_APP_SETTING_ACCESS_DELETE: "F2:D",
  PERMISSION_APP_SETTING_ACCESS_PRINT: "F2:P",
  PERMISSION_APP_SETTING_CLIENT_APP_VERSION_VIEW: "F3:V",
  PERMISSION_APP_SETTING_CLIENT_APP_VERSION_ADD: "F3:A",
  PERMISSION_APP_SETTING_CLIENT_APP_VERSION_UPDATE: "F3:U",
  PERMISSION_APP_SETTING_CLIENT_APP_VERSION_DELETE: "F3:D",
  PERMISSION_APP_SETTING_CLIENT_APP_VERSION_PRINT: "F3:P",
  PERMISSION_APP_SETTING_ENTITY_VIEW: "F4:V",
  PERMISSION_APP_SETTING_ENTITY_ADD: "F4:A",
  PERMISSION_APP_SETTING_ENTITY_UPDATE: "F4:U",
  PERMISSION_APP_SETTING_ENTITY_DELETE: "F4:D",
  PERMISSION_APP_SETTING_ENTITY_PRINT: "F4:P",
  PERMISSION_APP_SETTING_FEATURE_VIEW: "F5:V",
  PERMISSION_APP_SETTING_FEATURE_ADD: "F5:A",
  PERMISSION_APP_SETTING_FEATURE_UPDATE: "F5:U",
  PERMISSION_APP_SETTING_FEATURE_DELETE: "F5:D",
  PERMISSION_APP_SETTING_FEATURE_PRINT: "F5:P",
  PERMISSION_APP_SETTING_PARAMETER_VIEW: "F6:V",
  PERMISSION_APP_SETTING_PARAMETER_ADD: "F6:A",
  PERMISSION_APP_SETTING_PARAMETER_UPDATE: "F6:U",
  PERMISSION_APP_SETTING_PARAMETER_DELETE: "F6:D",
  PERMISSION_APP_SETTING_PARAMETER_PRINT: "F6:P",
  PERMISSION_APP_SETTING_PARAMETER_ITEM_VIEW: "F7:V",
  PERMISSION_APP_SETTING_PARAMETER_ITEM_ADD: "F7:A",
  PERMISSION_APP_SETTING_PARAMETER_ITEM_UPDATE: "F7:U",
  PERMISSION_APP_SETTING_PARAMETER_ITEM_DELETE: "F7:D",
  PERMISSION_APP_SETTING_PARAMETER_ITEM_PRINT: "F7:P",
  PERMISSION_APP_SETTING_ROLE_VIEW: "F8:V",
  PERMISSION_APP_SETTING_ROLE_ADD: "F8:A",
  PERMISSION_APP_SETTING_ROLE_UPDATE: "F8:U",
  PERMISSION_APP_SETTING_ROLE_DELETE: "F8:D",
  PERMISSION_APP_SETTING_ROLE_PRINT: "F8:P",
  PERMISSION_APP_SETTING_TASK_SCHEDULE_VIEW: "F9:V",
  PERMISSION_APP_SETTING_TASK_SCHEDULE_ADD: "F9:A",
  PERMISSION_APP_SETTING_TASK_SCHEDULE_UPDATE: "F9:U",
  PERMISSION_APP_SETTING_TASK_SCHEDULE_DELETE: "F9:D",
  PERMISSION_APP_SETTING_TASK_SCHEDULE_PRINT: "F9:P",
  PERMISSION_APP_SETTING_USER_VIEW: "F10:V",
  PERMISSION_APP_SETTING_USER_ADD: "F10:A",
  PERMISSION_APP_SETTING_USER_UPDATE: "F10:U",
  PERMISSION_APP_SETTING_USER_DELETE: "F10:D",
  PERMISSION_APP_SETTING_USER_PRINT: "F10:P",
  PERMISSION_MASTER_DATA_VIEW: "F11:V",
  PERMISSION_MASTER_DATA_ADD: "F11:A",
  PERMISSION_MASTER_DATA_UPDATE: "F11:U",
  PERMISSION_MASTER_DATA_DELETE: "F11:D",
  PERMISSION_MASTER_DATA_PRINT: "F11:P",
  PERMISSION_MASTER_DATA_BATTERY_VIEW: "F12:V",
  PERMISSION_MASTER_DATA_BATTERY_ADD: "F12:A",
  PERMISSION_MASTER_DATA_BATTERY_UPDATE: "F12:U",
  PERMISSION_MASTER_DATA_BATTERY_DELETE: "F12:D",
  PERMISSION_MASTER_DATA_BATTERY_PRINT: "F12:P",
  PERMISSION_MASTER_DATA_CABINET_VIEW: "F13:V",
  PERMISSION_MASTER_DATA_CABINET_ADD: "F13:A",
  PERMISSION_MASTER_DATA_CABINET_UPDATE: "F13:U",
  PERMISSION_MASTER_DATA_CABINET_DELETE: "F13:D",
  PERMISSION_MASTER_DATA_CABINET_PRINT: "F13:P",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_VIEW: "F14:V",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_ADD: "F14:A",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_UPDATE: "F14:U",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_DELETE: "F14:D",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_PRINT: "F14:P",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_LOG_VIEW: "F15:V",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_LOG_ADD: "F15:A",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_LOG_UPDATE: "F15:U",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_LOG_DELETE: "F15:D",
  PERMISSION_MASTER_DATA_CABINET_DETAIL_LOG_PRINT: "F15:P",
  PERMISSION_MASTER_DATA_CITY_VIEW: "F16:V",
  PERMISSION_MASTER_DATA_CITY_ADD: "F16:A",
  PERMISSION_MASTER_DATA_CITY_UPDATE: "F16:U",
  PERMISSION_MASTER_DATA_CITY_DELETE: "F16:D",
  PERMISSION_MASTER_DATA_CITY_PRINT: "F16:P",
  PERMISSION_MASTER_DATA_CUSTOMER_VIEW: "F17:V",
  PERMISSION_MASTER_DATA_CUSTOMER_ADD: "F17:A",
  PERMISSION_MASTER_DATA_CUSTOMER_UPDATE: "F17:U",
  PERMISSION_MASTER_DATA_CUSTOMER_DELETE: "F17:D",
  PERMISSION_MASTER_DATA_CUSTOMER_PRINT: "F17:P",
  PERMISSION_MASTER_DATA_IOT_DEVICE_VIEW: "F18:V",
  PERMISSION_MASTER_DATA_IOT_DEVICE_ADD: "F18:A",
  PERMISSION_MASTER_DATA_IOT_DEVICE_UPDATE: "F18:U",
  PERMISSION_MASTER_DATA_IOT_DEVICE_DELETE: "F18:D",
  PERMISSION_MASTER_DATA_IOT_DEVICE_PRINT: "F18:P",
  PERMISSION_MASTER_DATA_MOTORCYCLE_VIEW: "F19:V",
  PERMISSION_MASTER_DATA_MOTORCYCLE_ADD: "F19:A",
  PERMISSION_MASTER_DATA_MOTORCYCLE_UPDATE: "F19:U",
  PERMISSION_MASTER_DATA_MOTORCYCLE_DELETE: "F19:D",
  PERMISSION_MASTER_DATA_MOTORCYCLE_PRINT: "F19:P",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_VIEW: "F20:V",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_ADD: "F20:A",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_UPDATE: "F20:U",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_DELETE: "F20:D",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_PRINT: "F20:P",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_LOG_VIEW: "F21:V",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_LOG_ADD: "F21:A",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_LOG_UPDATE: "F21:U",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_LOG_DELETE: "F21:D",
  PERMISSION_MASTER_DATA_MOTORCYCLE_BATTERY_LOG_PRINT: "F21:P",
  PERMISSION_MASTER_DATA_MOTORCYCLE_OWNERSHIP_VIEW: "F22:V",
  PERMISSION_MASTER_DATA_MOTORCYCLE_OWNERSHIP_ADD: "F22:A",
  PERMISSION_MASTER_DATA_MOTORCYCLE_OWNERSHIP_UPDATE: "F22:U",
  PERMISSION_MASTER_DATA_MOTORCYCLE_OWNERSHIP_DELETE: "F22:D",
  PERMISSION_MASTER_DATA_MOTORCYCLE_OWNERSHIP_PRINT: "F22:P",
  PERMISSION_MASTER_DATA_MOTORCYCLE_REGISTERED_VIEW: "F23:V",
  PERMISSION_MASTER_DATA_MOTORCYCLE_REGISTERED_ADD: "F23:A",
  PERMISSION_MASTER_DATA_MOTORCYCLE_REGISTERED_UPDATE: "F23:U",
  PERMISSION_MASTER_DATA_MOTORCYCLE_REGISTERED_DELETE: "F23:D",
  PERMISSION_MASTER_DATA_MOTORCYCLE_REGISTERED_PRINT: "F23:P",
  PERMISSION_MASTER_DATA_PRODUCT_VIEW: "F24:V",
  PERMISSION_MASTER_DATA_PRODUCT_ADD: "F24:A",
  PERMISSION_MASTER_DATA_PRODUCT_UPDATE: "F24:U",
  PERMISSION_MASTER_DATA_PRODUCT_DELETE: "F24:D",
  PERMISSION_MASTER_DATA_PRODUCT_PRINT: "F24:P",
  PERMISSION_MASTER_DATA_PRODUCT_CATEGORY_VIEW: "F25:V",
  PERMISSION_MASTER_DATA_PRODUCT_CATEGORY_ADD: "F25:A",
  PERMISSION_MASTER_DATA_PRODUCT_CATEGORY_UPDATE: "F25:U",
  PERMISSION_MASTER_DATA_PRODUCT_CATEGORY_DELETE: "F25:D",
  PERMISSION_MASTER_DATA_PRODUCT_CATEGORY_PRINT: "F25:P",
  PERMISSION_MASTER_DATA_PROVINCE_VIEW: "F26:V",
  PERMISSION_MASTER_DATA_PROVINCE_ADD: "F26:A",
  PERMISSION_MASTER_DATA_PROVINCE_UPDATE: "F26:U",
  PERMISSION_MASTER_DATA_PROVINCE_DELETE: "F26:D",
  PERMISSION_MASTER_DATA_PROVINCE_PRINT: "F26:P",
  PERMISSION_MASTER_DATA_SIM_CARD_VIEW: "F27:V",
  PERMISSION_MASTER_DATA_SIM_CARD_ADD: "F27:A",
  PERMISSION_MASTER_DATA_SIM_CARD_UPDATE: "F27:U",
  PERMISSION_MASTER_DATA_SIM_CARD_DELETE: "F27:D",
  PERMISSION_MASTER_DATA_SIM_CARD_PRINT: "F27:P",
  PERMISSION_MASTER_DATA_STAFF_VIEW: "F28:V",
  PERMISSION_MASTER_DATA_STAFF_ADD: "F28:A",
  PERMISSION_MASTER_DATA_STAFF_UPDATE: "F28:U",
  PERMISSION_MASTER_DATA_STAFF_DELETE: "F28:D",
  PERMISSION_MASTER_DATA_STAFF_PRINT: "F28:P",
  PERMISSION_TRANSACTION_DATA_VIEW: "F29:V",
  PERMISSION_TRANSACTION_DATA_ADD: "F29:A",
  PERMISSION_TRANSACTION_DATA_UPDATE: "F29:U",
  PERMISSION_TRANSACTION_DATA_DELETE: "F29:D",
  PERMISSION_TRANSACTION_DATA_PRINT: "F29:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_BATTERY_VIEW: "F30:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_BATTERY_ADD: "F30:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_BATTERY_UPDATE: "F30:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_BATTERY_DELETE: "F30:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_BATTERY_PRINT: "F30:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_HEADER_VIEW: "F31:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_HEADER_ADD: "F31:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_HEADER_UPDATE: "F31:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_HEADER_DELETE: "F31:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_HEADER_PRINT: "F31:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_ITEM_VIEW: "F32:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_ITEM_ADD: "F32:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_ITEM_UPDATE: "F32:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_ITEM_DELETE: "F32:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_ITEM_PRINT: "F32:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_MOTORCYCLE_VIEW: "F33:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_MOTORCYCLE_ADD: "F33:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_MOTORCYCLE_UPDATE: "F33:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_MOTORCYCLE_DELETE: "F33:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_MOTORCYCLE_PRINT: "F33:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_PRODUCT_VIEW: "F34:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_PRODUCT_ADD: "F34:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_PRODUCT_UPDATE: "F34:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_PRODUCT_DELETE: "F34:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_RENT_PRODUCT_PRINT: "F34:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_STATUS_VIEW: "F35:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_STATUS_ADD: "F35:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_STATUS_UPDATE: "F35:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_STATUS_DELETE: "F35:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_STATUS_PRINT: "F35:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TOPUP_VIEW: "F36:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TOPUP_ADD: "F36:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TOPUP_UPDATE: "F36:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TOPUP_DELETE: "F36:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TOPUP_PRINT: "F36:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TYPE_VIEW: "F37:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TYPE_ADD: "F37:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TYPE_UPDATE: "F37:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TYPE_DELETE: "F37:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_TYPE_PRINT: "F37:P",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_WALLET_VIEW: "F38:V",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_WALLET_ADD: "F38:A",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_WALLET_UPDATE: "F38:U",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_WALLET_DELETE: "F38:D",
  PERMISSION_TRANSACTION_DATA_TRANSACTION_WALLET_PRINT: "F38:P",
  PERMISSION_BACKGROUND_VIEW: "F39:V",
  PERMISSION_BACKGROUND_ADD: "F39:A",
  PERMISSION_BACKGROUND_UPDATE: "F39:U",
  PERMISSION_BACKGROUND_DELETE: "F39:D",
  PERMISSION_BACKGROUND_PRINT: "F39:P",

  SPECIAL_PERMISSION_ADMINISTRATOR: "ADMINISTRATOR",
  SPECIAL_PERMISSION_MOBILE: "MOBILE",
  SPECIAL_PERMISSION_WEB: "WEB",
  SPECIAL_PERMISSION_ENGINE: "ENGINE",

  PERMISSION_LEVEL_DIRECTOR: "DIRECTOR",
  PERMISSION_LEVEL_MANAGER: "MANAGER",
  PERMISSION_LEVEL_SUPERVISOR: "SUPERVISOR",
  PERMISSION_LEVEL_STAFF: "STAFF",
};
